import * as React from 'react'
import parse from 'html-react-parser'
import { useTranslation } from '../../../hooks/useTranslation'
import { Button, Card, Typography } from '~/components/_atoms'
import YnsIcon from '~/components/icons/YnsIcon'

export function AylaCardBig({ className }) {
  const { t } = useTranslation()
  const features = [
    { icon: 'document', text: t('ayla_card_big.features.cover_letter') },
    {
      icon: 'briefcase',
      text: t('ayla_card_big.features.skills'),
    },
    { icon: 'research', text: t('ayla_card_big.features.research') },
    { icon: 'interview', text: t('ayla_card_big.features.interview') },
    { icon: 'linkedin', text: t('ayla_card_big.features.linkedin') },
    { icon: 'builder', text: t('ayla_card_big.features.thank_you') },
  ]
  return (
    <Card
      className={className}
      title={parse(t('ayla_card_big.title'))}
      titleColor="primary"
      actions={
        <div className="yns-stack flex flex-row flex-wrap items-center gap-2 ">
          <Button
            variant="ghost"
            size="sm"
            href="/orientation/meet_ayla"
            className="ga-trackable w-full @sm:w-auto"
          >
            {parse(t('ayla_card_big.action_text'))}
          </Button>
        </div>
      }
    >
      <div className="flex h-full flex-col justify-between">
        <div className="grid h-full grid-cols-1 gap-4 sm:grid-cols-2">
          {features.map((feature) => (
            <div key={feature.text} className="flex items-center gap-3">
              <div className="rounded-full bg-intoo-blue-light p-4">
                <YnsIcon
                  name={feature.icon}
                  className="h-8 w-8 flex-shrink-0 text-primary"
                />
              </div>
              <Typography className="!mb-0">{feature.text}</Typography>
            </div>
          ))}
        </div>
      </div>
    </Card>
  )
}
